import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations';
import { getUserWatchState } from './redux/selectors';
import { clickWatch } from './redux/actionCreators';
import { BiContext } from '@wix/da-bi/pkg/BiLogger.context';
import { BiData } from '@wix/da-bi/pkg/events';
import { pushGlobalConfirmationModal } from '../Modals/redux/actionCreators';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
function useWatchButtonText(isWatching, isWatchingBack) {
    const { t } = useTranslation();
    if (isWatching) {
        return t('watchButton.watching');
    }
    if (isWatchingBack) {
        return t('watchButton.watchBack');
    }
    return t('watchButton.watch');
}
export function useWatchButton(user, initialIsWatching = !!(user === null || user === void 0 ? void 0 : user.isWatching), isWatchingBack = false, disabled = false, onToggleWatchSuccess, extraBiData) {
    const { isWatching, isLoading } = useSelector((state)=>getUserWatchState(state, user, {
            isWatching: initialIsWatching
        }), shallowEqual);
    const dispatch = useDispatch();
    const text = useWatchButtonText(isWatching, isWatchingBack);
    const biContext = useContext(BiContext);
    const biData = useMemo(()=>BiData(_object_spread({
            evid: 380,
            is_watching: isWatching ? 0 : 1,
            friendid: user === null || user === void 0 ? void 0 : user.useridUuid,
            itemid: biContext.itemid,
            typeid: biContext.typeid,
            rank: biContext.rank,
            sectionid: biContext.sectionid,
            sectionname: biContext.sectionname,
            section_typeid: biContext.section_typeid,
            sectiontype: biContext.sectiontype,
            sectionrank: biContext.sectionrank,
            sort_type: biContext.sort_type,
            reason_shown: biContext.reason_shown,
            notification_type: biContext.notification_type
        }, extraBiData)), [
        biContext.itemid,
        biContext.notification_type,
        biContext.rank,
        biContext.reason_shown,
        biContext.section_typeid,
        biContext.sectionid,
        biContext.sectionname,
        biContext.sectionrank,
        biContext.sectiontype,
        biContext.sort_type,
        biContext.typeid,
        extraBiData,
        isWatching,
        user === null || user === void 0 ? void 0 : user.useridUuid
    ]);
    const onClick = useCallback(()=>{
        yieldToMain(()=>{
            if (disabled || !user) {
                return;
            }
            if (isWatching) {
                const { is_watching: _discard } = biData, unwatchBiData = _object_without_properties(biData, [
                    "is_watching"
                ]);
                dispatch(pushGlobalConfirmationModal({
                    titleTransKey: 'watchButton.unwatchConfirmModal.title',
                    textTransKey: 'watchButton.unwatchConfirmModal.description',
                    confirmBtnLabelTransKey: 'watchButton.unwatchConfirmModal.confirmButton.label',
                    confirmBtnBiData: BiData(_object_spread_props(_object_spread({}, unwatchBiData), {
                        evid: 385
                    })),
                    cancelBtnLabelTransKey: 'watchButton.unwatchConfirmModal.cancelButton.label',
                    translationOptions: {
                        username: user.username
                    },
                    icon: /*#__PURE__*/ React.createElement(Warning, null),
                    onConfirm: ()=>{
                        dispatch(clickWatch(user, isWatching, onToggleWatchSuccess));
                    }
                }));
            } else {
                dispatch(clickWatch(user, isWatching, onToggleWatchSuccess));
            }
        });
    }, [
        disabled,
        user,
        isWatching,
        dispatch,
        biData,
        onToggleWatchSuccess
    ]);
    return {
        text,
        onClick,
        isLoading,
        isWatching,
        biData
    };
}

//# sourceMappingURL=useWatchButton.js.map